import { TeamState } from './team.js';
import { Configuration } from './configuration.js';
import { ObjectiveBonusPenalty } from './objective-bonus-penalty.js';
import { AnswerPenaltyState } from './bonus.js';
export class AnswerPenalty extends ObjectiveBonusPenalty<AnswerPenaltyState> {
    static fromState(state: AnswerPenaltyState, teams: TeamState[], config: Configuration) {
        const team = teams.find(t => t.id === state.teamId) || null;
        const oc = config.answers[state.objectiveId];
        if (!team) {
            throw new Error(`Team ${state.teamId} for answer penalty not found`);
        }
        return (
            team &&
            oc &&
            new AnswerPenalty(team, oc, state.valid, new Date(state.awarded), state.index)
        );
    }
    toState(config: Configuration): AnswerPenaltyState {
        return {
            teamId: this.team.id,
            valid: this.valid,
            objectiveId: config.answers.findIndex(o => o.name === this.config.name),
            awarded: this.awarded.getTime(),
            index: this.index
        };
    }
    score(config: Configuration) {
        return -(config.answerPenalties[this.index] || 0) * this.config.points;
    }
}
